import MicroModal from 'micromodal';
import Snackbar from 'node-snackbar';

export default class Micromodal {
  // html selector for the component
  static selectorString() {
    return '.js-micromodal-button';
  }

  constructor(rootNode) {
    this.$refs = {
      rootNode,
    };

    this.data = {
      modalId: rootNode.dataset.modalId,
      packageId: rootNode.dataset.packageId,
      isOpen: false,
    };

    this.setupClickHandler();
  }

  setupClickHandler() {
    this.$refs.rootNode.addEventListener('click', e => {
      if (this.data.isOpen) this.closeModal();
      else this.openModal();
    });

    if (this.data.modalId === 'modal-packages') {
      const modal = document.querySelector(`#${this.data.modalId}`);
      const wpcf7 = modal.querySelector('.wpcf7');

      if (modal && wpcf7) {
        wpcf7.addEventListener('wpcf7mailsent', () => {
          MicroModal.close(this.data.modalId);
          Snackbar.show({
            pos: 'bottom-right',
            text: 'Anfrage wurde übermittelt.',
            actionText: 'OK',
          });
        });

        wpcf7.addEventListener('wpcf7invalid', () => {
          Snackbar.show({
            pos: 'bottom-right',
            text: 'Fehler: Überprüft eure Angaben.',
            actionText: 'OK',
          });
        });
      }
    }
  }

  openModal() {
    if (this.data.packageId) {
      const modal = document.getElementById(this.data.modalId);
      const inputField = modal.querySelector('textarea[name="message"]');

      if (this.data.packageId === 'package-custom') {
        const packageElem = this.$refs.rootNode.parentNode;
        const title = packageElem.querySelector('.Title');

        inputField.value = `${title.innerText}\n`;
      } else {
        const form = document.getElementById(this.data.packageId);
        const title = form.querySelector('.package-form-title');
        const checkboxes = [...form.querySelectorAll('.checkbox-checkbox:checked:not(:disabled)')];

        inputField.setAttribute('readonly', true);
        inputField.value = `${title.innerText}\n${checkboxes.map(item => item.parentNode.querySelector('strong').innerText).join(' ')}`;
      }
    }

    MicroModal.show(this.data.modalId, {
      awaitCloseAnimation: true,
      onClose: (modal) => this.data.packageId && this.clearModalInput(),
    });
  }

  clearModalInput() {
    if (this.data.packageId) {
      const modal = document.getElementById(this.data.modalId);
      const inputField = modal.querySelector('textarea[name="message"]');

      inputField.value = '';
      inputField.removeAttribute('readonly');
    }
  }

  closeModal() {
    MicroModal.close(this.data.modalId);
  }
}
